const doc = [({"da":({"js":({"admin":({"agendas":({"create_card":({"create_agenda":"Opret dagsorden"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;